import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthenticatedApp } from "./AuthenticatedApp";
import { KioskPage } from "./KioskPage";
import "./styles.css";
import "./functional.css";
import "./dispatch-fixes.css";
import "./cmms.css";
import "./ppm.css";
import "./cmms-role.css";
import "./helpdesk.css";
import "./cmms-admin.css";
import "./user-admin.css";
import "./attachments.css";
import "./platform-admin.css";
import "./sidebar-scroll.css";

const isKiosk = window.location.pathname === "/kiosk";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isKiosk ? <KioskPage /> : <AuthenticatedApp />}
  </StrictMode>,
);
if ("serviceWorker" in navigator && location.protocol === "https:") {
  addEventListener("load", () => navigator.serviceWorker.register("/sw.js"));
}
